import { type ThemeConfig } from 'ant-design-vue/es/config-provider/context';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import { theme as _theme } from 'ant-design-vue';
import { primaryColor, errorColor, borderColor } from '@/assets/styles/export.module.less';

export const locale = zhCN;

type Token = ThemeConfig['token'];
type Components = ThemeConfig['components'];

const token: Token = {
  colorPrimary: primaryColor,
  colorError: errorColor,
  colorBorder: borderColor,
  colorBgElevated: '#2C2C2E',
  colorPrimaryHover: primaryColor,
  fontFamily: 'PingFang SC',
};

const components: Components = {
  Button: {
    fontSize: 16,
    controlHeight: 52,
    borderRadius: 8,
  },
  Input: {
    fontSize: 14,
    controlHeight: 52,
    // colorBgContainer: 'transparent'
  },
  Form: {
    colorError: errorColor,
  },
  Segmented: {
    controlHeight: 42,
    borderRadius: 9,
    borderRadiusSM: 8,
    colorBgLayout: 'transparent',
    lineWidth: -8,
    lineWidthBold: 2,
  },
  Select: {
    controlHeight: 42,
    borderRadius: 9
  },
  Radio: {
    controlHeight: 42,
    fontSize: 13
  },
  Modal: {
    colorBgElevated: '#18181B'
  },
};

export const theme:ThemeConfig = {
  algorithm: _theme.darkAlgorithm,
  token,
  components
};